<template>
	<n-drawer
		v-model:show="active"
		placement="bottom"
		:theme-overrides="{ borderRadius: '24px' }"
		:min-height="454"
		height="454"
	>
		<div class="flex flex-col gap-8 px-6 py-8 pb-0">
			<div class="flex flex-col gap-5">
				<div class="flex items-center justify-center">
					<img
						src="/images/mobile-app-banner.svg"
						:alt="t('common.mobile_app_banner.image_alt')"
						class="w-15 min-w-15"
						width="60"
						height="120"
					/>
				</div>
				<div class="mx-auto flex max-w-120 flex-col gap-3">
					<div class="text-fs-xl mx-auto max-w-80 text-center font-bold">
						{{ t("common.mobile_app_banner.title") }}
					</div>
					<div class="text-tertiary text-center">
						{{ t("common.mobile_app_banner.description") }}
					</div>
				</div>
			</div>
			<div class="mx-auto flex w-full max-w-120 flex-col justify-stretch gap-6">
				<JMButton
					tag="a"
					type="primary"
					size="large"
					icon-name="carbon:download"
					icon-placement="right"
					class="w-full!"
					:href="deepLinkUrl"
					rel="noopener"
				>
					{{ t("common.mobile_app_banner.download_cta") }}
				</JMButton>
				<JMButton type="primary" text size="large" class="font-normal!" @click="close">
					{{ t("common.mobile_app_banner.continue_browser_cta") }}
				</JMButton>
			</div>
		</div>
	</n-drawer>
</template>

<script setup lang="ts">
import { NDrawer } from "naive-ui"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import JMButton from "@/components/common/JMButton.vue"
import { isMobile } from "@/utils"

const TRAILING_SLASH_REGEX = /\/$/

const active = ref(false)
const checkMobile = computed(() => isMobile())
const { t } = useI18n()

/**
 * Universal Link / App Link: se l'app è installata iOS/Android lo
 * intercettano e aprono direttamente l'app (AASA / assetlinks.json), altrimenti
 * il browser carica `OpenApp.vue` che reindirizza allo store corretto.
 * Deve essere usato come `href` di un vero `<a>` cliccato dall'utente,
 * altrimenti l'intercept non scatta.
 */
const deepLinkUrl = computed(() => {
	const base = import.meta.env.VITE_WEBSITE_BASE_URL?.replace(TRAILING_SLASH_REGEX, "") || ""
	return `${base}/open`
})

function open() {
	if (!checkMobile.value) {
		return
	}
	active.value = true
}

function close() {
	active.value = false
}

defineExpose({
	open,
	close
})
</script>
